import React from 'react';
import { Popconfirm, Tooltip, Button } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';

type DeliveryAlertButtonProps = {
  planned: number;
  actual: number;
};

const DeliveryAlertButton: React.FC<DeliveryAlertButtonProps> = ({ planned, actual }) => {
  const discrepancy = planned - actual;

  return (
    <Popconfirm
      trigger="click"
      title={
        <div className="delivery-alert-popup">
          <div className="fw-600 c-red mb-12"> 🚨 {discrepancy} Locations Not Completed</div>
          <div className="fs-14 c-666 mb-15">
            Planned Deliveries: {planned} | Actual Deliveries: {actual}
          </div>
        </div>
      }
      okText="View"
      okButtonProps={{ type: 'primary' }}
      cancelText="Cancel"
      onConfirm={() => {
        window.location.href = `/dashboard/operations`;
      }}
    >
      <Tooltip title={`Click: ${discrepancy} deliveries missing`}>
        <Button
          type="text"
          icon={<ExclamationCircleFilled className="c-orange-dark" />}
          size="small"
          className="delivery-alert-btn"
        />
      </Tooltip>
    </Popconfirm>
  );
};

export default DeliveryAlertButton;
